import { useState } from "react";
import {
	ConfigDetails,
	ConfigMetaToken,
	ConfigMetaTokens,
	ConfigSummaryAction,
	ConfigSummaryLine,
	ConfigSummaryPanel,
	EmptyState,
	SecondaryRail,
	SecondaryRailHeader,
	SecondaryRailLabel,
	SignatureName,
	SignatureSummaryContent,
	SignaturePosition,
	SignatureSummaryCard,
	SignatureSummaryGrid,
	SignatureType,
} from "../styles";

const ConfigSnapshot = ({
	enabled,
	revision,
	organizerCampusName,
	signatureCount,
	signatures,
}) => {
	const [expanded, setExpanded] = useState(false);
	const statusText = enabled ? "Activada" : "Desactivada";
	const revisionText = revision === null ? "-" : revision;
	const signatureText = `${signatureCount || 0} firma(s)`;

	return (
		<SecondaryRail>
			<SecondaryRailHeader>
				<SecondaryRailLabel>Configuración</SecondaryRailLabel>
			</SecondaryRailHeader>

			<ConfigSummaryPanel>
				<ConfigSummaryLine>
					<ConfigMetaTokens>
						<ConfigMetaToken $variant={enabled ? "success" : "neutral"}>
							{statusText}
						</ConfigMetaToken>
						<ConfigMetaToken>Rev. {revisionText}</ConfigMetaToken>
						<ConfigMetaToken>{organizerCampusName || "-"}</ConfigMetaToken>
						<ConfigMetaToken>{signatureText}</ConfigMetaToken>
					</ConfigMetaTokens>
					<ConfigSummaryAction
						type="button"
						aria-expanded={expanded}
						onClick={() => setExpanded(prev => !prev)}
					>
						{expanded ? "Ocultar" : "Ver firmas"}
					</ConfigSummaryAction>
				</ConfigSummaryLine>

				{expanded ? (
					<ConfigDetails>
						<SignatureSummaryGrid>
							{signatures.length === 0 ? (
								<EmptyState>No hay firmas configuradas.</EmptyState>
							) : (
								signatures.map((signature, index) => (
									<SignatureSummaryCard key={`${signature.slot}-${index}`}>
										<SignaturePosition>{signature.position}</SignaturePosition>
										<SignatureSummaryContent>
											<SignatureType title={signature.type}>
												{signature.type}
											</SignatureType>
											<SignatureName title={signature.name || "-"}>
												{signature.name || "-"}
											</SignatureName>
										</SignatureSummaryContent>
									</SignatureSummaryCard>
								))
							)}
						</SignatureSummaryGrid>
					</ConfigDetails>
				) : null}
			</ConfigSummaryPanel>
		</SecondaryRail>
	);
};

export default ConfigSnapshot;
